import { render, staticRenderFns } from "./SelectTag.vue?vue&type=template&id=5dad3c8d&scoped=true&"
import script from "./SelectTag.vue?vue&type=script&lang=js&"
export * from "./SelectTag.vue?vue&type=script&lang=js&"
import style0 from "./SelectTag.vue?vue&type=style&index=0&id=5dad3c8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad3c8d",
  null
  
)

export default component.exports